import { useState } from "react";
import AppState from "../../model/app";
import { setIsLoading, setAuthenticated, setStates, addNotification, shownNotification,
    setSound, setSoundEffect } from "../providers/app";

export function useApp(): [AppState, Function, Function, Function, Function, Function, Function, Function] {
    const notifications: any[] = [];
    const [state, setState] = useState({ isLoading: true, authenticated: false, userId: "",
        notifications: notifications, sound: true, soundEffect: true });

    return [state,
        (isLoading: boolean) => setIsLoading(setState, isLoading),
        (authenticated: boolean, userId: string = "", sound: boolean, soundEffect: boolean) =>
            setAuthenticated(setState, authenticated, userId, sound, soundEffect),
        (isLoading: boolean, authenticated: boolean, userId: string, sound: boolean, soundEffect: boolean) =>
            setStates(setState, isLoading, authenticated, userId, sound, soundEffect),
        (notification: any): void => addNotification(setState, notification),
        (notification: any): void => shownNotification(setState, notification),
        (sound: boolean): void => setSound(setState, sound),
        (soundEffect: boolean): void => setSoundEffect(setState, soundEffect),
    ];
}
